import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import SuperAdminPage from './pages/SuperAdminPage';
import PrivateRoute from './components/PrivateRoute';
import SuperAdminRoute from './components/SuperAdminRoute';
import { ToastProvider } from './context/ToastContext';

const App = () => {
  return (
    <Router>
      <ToastProvider>
        <Routes>
  <Route path="/" element={<LoginPage />} />
  <Route
    path="/superadmin"
    element={
      <SuperAdminRoute>
        <SuperAdminPage />
      </SuperAdminRoute>
    }
  />
  <Route
    path="/*"
    element={
      <PrivateRoute>
        <MainPage />
      </PrivateRoute>
    }
  />
</Routes>
      </ToastProvider>
    </Router>
  );
};

export default App;
